import styled from '@emotion/styled'

import Label from './Label'
import Legend from './Legend'

const FormRow = styled.div`
	gap: ${({ theme }) => theme.spaces.space2};
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-start;
	margin-bottom: ${({ theme }) => theme.spaces.space4};

	& > ${Legend} {
		margin-bottom: 0;
	}

	& > ${Label} {
		margin-bottom: 0;
	}
`

export default FormRow
